const isTouchEnabled = () => 'ontouchstart' in document.documentElement;

if (isTouchEnabled()) {
    window.document.body.classList.add('touch-enabled');
    window.document.addEventListener('touchstart', () => undefined, false); // fix :active selector on iOS
}
